import * as swcHelpers from '@swc/helpers';
import { isLineItemReorderable } from '../../../utils/is-line-item-reorderable.js';
import { getPrices } from '../utils/get-prices.js';
import { createImageUrl } from '../utils/create-image-url.js';
import { getProductTitle } from '../utils/get-product-title.js';
import { getProductSubtitle } from '../utils/get-product-subtitle.js';
import { getProductA11yLabel } from '../utils/get-product-a11y-label.js';
import { createLineItemId } from '../utils/create-line-item-id.js';

const mapProductType = (serverType)=>{
    switch(serverType.toLowerCase()){
        case 'frames':
            return 'frames';
        case 'sunglasses':
            return 'sunglasses';
        case 'solutions':
            return 'solutions';
        case 'ready-readers':
            return 'ready-readers';
        case 'accessories':
            return 'accessories';
        default:
            return 'sunglasses';
    }
};
const toBaseLineItem = (orderLineItem, intl, options = {})=>{
    const priceDetails = getPrices(orderLineItem);
    const id = createLineItemId(orderLineItem);
    return swcHelpers.objectSpread({
        id,
        lineItemId: id,
        productType: mapProductType(orderLineItem.product.productType),
        quantity: `${intl.getLabel('cart.item.quantity')}: ${orderLineItem.quantity}`,
        sku: orderLineItem.product.sku,
        imageUrl: createImageUrl(orderLineItem.product.mainImage, options),
        title: getProductTitle(orderLineItem, intl),
        subtitle: getProductSubtitle(orderLineItem, intl),
        altText: getProductA11yLabel(orderLineItem, intl),
        isReorderAvailable: isLineItemReorderable(orderLineItem)
    }, priceDetails);
};

export { toBaseLineItem };
//# sourceMappingURL=base-line-item.js.map
